import { useAppStore, useVODStore } from '@/shared/store'
import { getErrorMessage } from '@/shared/lib/getErrorMessage'
import { useCallback, useState } from 'react'
import { useVODService } from '@/app/context/DIContext/DIServices'
import VodDetails from '../vodClasses/vodDetails'

const useItemDetails = () => {
    const [details, setDetails] = useState<VodDetails | null>(null)
    const [error, setError] = useState<unknown>()
    const { actualProfile } = useAppStore()
    const vodCachedDetails = useVODStore((state) => state.vodCachedDetails)
    const { getVodDetails } = useVODService()
    const { id: profileId } = actualProfile ?? {}

    const getItemDetails = useCallback(
        async (
            item: {
                productId: string | null
                assetType: string | undefined
                id: string
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            isForceFetchDetails = false
        ) => {
            // setDetails(null)
            const { productId, assetType } = item
            if (!productId || !assetType) return

            // const cachedItem = vodCachedDetails.find(
            //     (element) => element.vodItemId === id
            // )
            //
            // if (cachedItem && !isForceFetchDetails) {
            //     setDetails(cachedItem.details)
            //     return
            // }

            try {
                const details = await getVodDetails(
                    productId,
                    assetType,
                    profileId
                )
                if (details) {
                    const vodItemDetails = new VodDetails(details)
                    setDetails(vodItemDetails)
                }
            } catch (error) {
                getErrorMessage('useItemDetails', error)
                setError(error)
            }
            return () => {
                setDetails(null)
                setError(null)
            }
        },
        [vodCachedDetails, getVodDetails]
    )
    return { details, getItemDetails, error }
}

export default useItemDetails
